export default __webpack_public_path__ + "static/media/Logo-Icon.9c6cc3e5.svg";